import { useId, type ReactNode } from 'react';
import styles from './PageHeader.module.css';

export function PageHeader({
  title,
  description,
  eyebrow,
  actions,
  meta,
  headingId,
  className,
}: {
  title: ReactNode;
  description?: ReactNode;
  eyebrow?: ReactNode;
  actions?: ReactNode;
  meta?: ReactNode;
  headingId?: string;
  className?: string;
}): ReactNode {
  const generatedId = useId();
  const id = headingId ?? generatedId;

  return (
    <header className={[styles.header, className].filter(Boolean).join(' ')}>
      <div className={styles.identity}>
        {eyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
        <h2 id={id} className={styles.title}>
          {title}
        </h2>
        {description ? <p className={styles.description}>{description}</p> : null}
        {meta ? <div className={styles.meta}>{meta}</div> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </header>
  );
}
